import { render, staticRenderFns } from "./expert_edit.vue?vue&type=template&id=3f4178c3"
import script from "./expert_edit.vue?vue&type=script&lang=js"
export * from "./expert_edit.vue?vue&type=script&lang=js"
import style0 from "./expert_edit.vue?vue&type=style&index=0&id=3f4178c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports